import type { MsAdlActivityLabels } from "../en-GB/msAdlCopy";

export const msAdlCopyDa: MsAdlActivityLabels = {
    Walking: "Gang",
    Cooking: "Madlavning",
    Driving: "Kørsel",
    Shopping: "Indkøb",
    Work: "Arbejde",
    Sport: "Sport",
    Housework: "Husarbejde",
    Socialising: "Socialt samvær",
};
